<template>
    <div id="secondBack">
        <h4>APP点击下载总量：{{ anzuoLoad + pingguoLoad}}, 安卓点击下载总量：{{  anzuoLoad }}，苹果点击下载总量{{ pingguoLoad }}</h4>
        <div class="section3">
            <h4>【1】轮播图一 （建议尺寸710*298）</h4>
            <el-row>
                <el-col :span="7">
                    <input  type="file" ref="file1">
                    <div v-if="!lunTrue1">上传轮训图：</div>
                            <img v-else :src="lunbo1.appPopImg" alt="" width="150" height="150">  
                </el-col>
                <el-col :span="7">
                    <label style="width:80px;">跳转类型：</label>
                     <el-select v-model="lunbo1.appPopType"
                    placeholder="请选择" >
                        <el-option v-for="item in linkStateOption" :value="item.id" :key="item.id" :label="item.name "></el-option>
                    </el-select>
                </el-col>
                 <el-col :span="5">
                    <label style="width:100px;">跳转地址：</label>
                    <el-input v-model="lunbo1.appPopValue"  label="请输入"></el-input>
                </el-col>
                 <el-col style="width:100px;" :span="1">
                     <el-button type="primary"  @click="secondBackDiagnoseHandler">更新</el-button>
                </el-col>

            </el-row> 
          
        </div>
         <div class="section3">
            <h4>【2】轮播图二（建议尺寸710*298）</h4>
            <el-row>
                <el-col :span="7">
              <input  type="file" ref="file2">
                    <div v-if="!lunTrue2">上传轮播图：</div>
                            <img v-else :src="lunbo2.appPopImg" alt="" width="150" height="150">  
                </el-col>
                <el-col :span="7">
                    <label style="width:80px;">跳转类型：</label>
                     <el-select v-model="lunbo2.appPopType"
                    placeholder="请选择">
                        <el-option v-for="item in linkStateOption" :value="item.id" :key="item.id" :label="item.name "></el-option>
                    </el-select>
                </el-col>
                 <el-col :span="5">
                    <label style="width:100px;">跳转地址：</label>
                    <el-input v-model="lunbo2.appPopValue"  label="请输入"></el-input>
                </el-col>
                 <el-col style="width:100px;" :span="1">
                     <el-button type="primary"  @click="secondBackDiagnoseHandler1">更新</el-button>
                </el-col>

            </el-row> 
          
        </div>

        <div class="section3">
            <h4>【3】轮播图三（建议尺寸710*298）</h4>
            <el-row>
                <el-col :span="7">
              <input  type="file" ref="file3">
                    <div v-if="!lunTrue3">上传轮播图：</div>
                            <img v-else :src="lunbo3.appPopImg" alt="" width="150" height="150">  
                </el-col>
               <el-col :span="7">
                    <label style="width:80px;">跳转类型：</label>
                     <el-select v-model="lunbo3.appPopType"
                    placeholder="请选择" >
                        <el-option v-for="item in linkStateOption" :value="item.id" :key="item.id" :label="item.name "></el-option>
                    </el-select>
                </el-col>
                 <el-col :span="5">
                    <label style="width:100px;">跳转地址：</label>
                    <el-input v-model="lunbo3.appPopValue"  label="请输入"></el-input>
                </el-col>
                 <el-col style="width:100px;" :span="1">
                     <el-button type="primary"  @click="secondBackDiagnoseHandler2">更新</el-button>
                </el-col>

            </el-row> 
          
        </div>


        <div class="section1">
            <h4>【4】 APP换卡提示</h4>
            <el-row >
                 <el-col :span="2">
                    <label>标题：</label>
                    <el-input v-model="huanka.title" ></el-input>
                </el-col> 

                <el-col :span="5">
                    <label>内容：</label>
                    <el-input v-model="huanka.context" ></el-input>
                </el-col>

                <el-col :span="3">
                    <label >跳转类型：</label>
                     <el-select v-model="huanka.appPopType"
                    placeholder="请选择">
                        <el-option v-for="item in linkStateOption" :value="item.id" :key="item.id" :label="item.name "></el-option>
                    </el-select>
                </el-col> 
                <el-col :span="5">
                    <label>跳转地址：</label>
                    <el-input v-model="huanka.appPopValue" ></el-input>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updateSecondBackStateHandler">更新</el-button>
                </el-col>

            </el-row>
        </div>
      

        <div class="section2">
            <h4>【5】 客服链接</h4>
            <el-row>
                 <el-col :span="8">
                    <el-input v-model="kefuUrl" ></el-input>
                </el-col>

                <el-col :span="1">
                     <el-button type="primary"   @click="updateBalanceRecharge()">更新</el-button>
                </el-col>
            </el-row>
        </div>


          <div class="section2">
            <h4>【6】 支付通道配置《扫码支付，请前往系统管理->参数设置中配置》</h4>
            <el-row>
                <el-col :span="3" v-for=" item in payChanle" :key="item.id">
                    <label >{{item.alias}}: </label>&nbsp;
                    <el-switch v-model="item.enable"></el-switch>
                </el-col>

                <el-col :span="1">
                     <el-button type="primary" @click="updatePayChannel()" >更新</el-button>
                </el-col>
            </el-row>
           
        </div>




        <div class="section1">
            <h4>【7】 APP微信H5商户单独配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">微信商户号：</label>
                    <el-input style="width:180px;" v-model="wxSubId" placeholder="请输入"></el-input>
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">微信商户密钥：</label>
                    <el-input style="width:220px;" v-model="wxSubKey" placeholder="请输入"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePayWx()">保 存</el-button>
                </el-col>
            </el-row> 
        </div>

        <!-- <div class="section1">
            <h4>【8】 APP微信扫码商户配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">微信商户号：</label>
                    <el-input style="width:180px;" v-model="wxSubIdImg" placeholder="请输入"></el-input>
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">微信商户密钥：</label>
                    <el-input style="width:220px;" v-model="wxSubKeyImg" placeholder="请输入"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePayWxImg()">保 存</el-button>
                </el-col>
            </el-row> 
        </div>

        <div class="section1">
            <h4>【9】 斗洪扫码商户配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">斗洪商户号：</label>
                    <el-input style="width:180px;" v-model="dhSubId" placeholder="请输入666开头商户号"></el-input>
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">斗洪商户公钥：</label>
                    <el-input style="width:220px;" v-model="dhSubKey" placeholder="请输入"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePaydh()">保 存</el-button>
                </el-col>
            </el-row> 
        </div>

        

        <div class="section1">
            <h4>【10】 APP乐刷扫码商户配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">乐刷商户号：</label>
                    <el-input style="width:180px;" v-model="lsSubId" placeholder="请输入"></el-input>
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">乐刷商户密钥：</label>
                    <el-input style="width:220px;" v-model="lsSubKey" placeholder="请输入"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePayLs()">保 存</el-button>
                </el-col>
            </el-row> 
        </div> -->

         <!-- <div class="section1">
            <h4>【8】 支付宝商户配置（H5和APP通用）</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">APPID：</label>
                    <el-input style="width:180px;" v-model="aliSubId" placeholder="请输入"></el-input>
                </el-col>
                <el-col :span="7">
                    <label style="width:120px;">应用私钥：</label>
                    <el-input style="width:220px;" v-model="aliSubKey" placeholder="请输入"></el-input> 
                </el-col>
                 <el-col :span="7">
                    <label style="width:120px;">支付宝公钥：</label>
                    <el-input style="width:220px;" v-model="aliPubKey" placeholder="请输入"></el-input> 
                </el-col>
                <el-col :span="1">
                    <el-button type="primary"  @click="updatePayAli()">保 存</el-button>
                </el-col>
            </el-row> 
        </div> -->



    </div>
</template>

<script>
import {getSecondBackInfo, updateSecondBackState, getBindPhoneInfo, updateBindPhoneState, secondBackDiagnose, querySecondBack,querySysConfigCoupon,updateSysConfigCoupon,queryCouponList, selectAdminCollectionConfig, adminCollectionConfig} from '@/api/customers.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            pingguoLoad:'',
            anzuoLoad:'',

            wxSubId:'',
            wxSubKey:'',

            dhSubId:'',
            dhSubKey:'',

            wxSubIdImg:'',
            wxSubKeyImg:'',

            lsSubId:'',
            lsSubKey:'',

            aliSubId:'',
            aliSubKey:'',
            aliPubKey:'',


            
            kefuUrl:'',
            huanka:{
                'appPopType':null,
                'title':null,
                'context':null,
                'appPopValue':null
            },
            lunTrue1:false,
            lunTrue2:false,
            lunTrue3:false,
            lunbo1:{
                'appPopType':null,
                'appPopImg':null,
                'appImgCount':null,
                'appPopValue':null
            },
            lunbo2:{
                'appPopType':null,
                'appPopImg':null,
                'appImgCount':null,
                'appPopValue':null
            },
             linkStateOption:[
            {'id':3,'name':'跳转第三方链接'},
              {'id':4,'name':'跳转APP内部链接'}
        ],
          bindPhoneOption:[
            {'id':5,'name':'国政通验证'},
              {'id':6,'name':'手机号验证'},
                {'id':9,'name':'不需要认证'}
        ],
            lunbo3:{
                'appPopType':null,
                'appPopImg':null,
                'appImgCount':null,
                'appPopValue':null
            },
            secondBackState: '',
            dayOfBack:100,
            maxMoney:5,
            bindState: 9,
            isUserOpen: '',
            isAdminOpen: '',
            day: 1,
            coupon:{
                "is_enable":0,
                "id":null,
                "title":''
            }, 
            couponList:[],
            loading: false,


            //收款配置
            collectionConfigShowData: {
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                collectPkcsUrl: null,
            },
            collectPkcsFileName:'',
            collectionConfigVisible: false,
            collectionConfigFormdata:{
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                p12: null,
                collectPkcsUrl: null,
            },
            collectionConfigRules: {
                wxAppId: [
                    { required: true, message: '请输入wxAppId', trigger: 'blur' },
                ],
                wxMchId: [
                    { required: true, message: '请输入wxMchId', trigger: 'blur' },
                ],
                wxKeySign: [
                    { required: true, message: '请输入wxKeySign', trigger: 'blur' },
                ],
                wxAppSecret: [
                    { required: true, message: '请输入wxAppSecret', trigger: 'blur' },
                ],
            },

            //支付通道配置
            payChanle:[],

            //邮费配置
            postageForm:{
                is_enable: null,
                priceRmb: null,
                is_auto_back: null,
            },

            areaOption: [
                {name:'北京',key:11},
                {name:'天津',key:12 },
                {name:'河北',key:13 },
                {name:'山西',key:14 },
                {name:'内蒙古',key:15},
                {name:'辽宁',key:21},
                {name:'吉林',key:22},
                {name:'黑龙江',key:23},
                {name:'上海',key:31 },
                {name:'江苏',key:32 },
                {name:'浙江',key:33},
                {name:'安徽',key:34 },
                {name:'福建',key:35 },
                {name:'江西',key:36 },
                {name:'山东',key:37},
                {name:'河南',key:41 },
                {name:'湖北',key:42 },
                {name:'湖南',key:43},
                {name:'广东',key:44 },
                {name:'广西',key:45 },
                {name:'海南',key:46},
                {name:'重庆',key:50},
                {name:'四川',key:51},
                {name:'贵州',key:52},
                {name:'云南',key:53},
                {name:'西藏',key:54},
                {name:'陕西',key:61},
                {name:'甘肃',key:62},
                {name:'青海',key:63},
                {name:'宁夏',key:64},
                {name:'新疆',key:65},
                {name:'台湾',key:71},
                {name:'香港',key:81},
                {name:'澳门',key:82},
            ],//字典

            authenticationCinfig:{
                is_enable: 0,
                limit_area: null,
            },

            flowLimitConfig:{
                suppliers:null,
                datas:null,
                states:'0'
            },

            intoNoLimitConfig:{
                cofValue: null,
            },

            branchSupplierOption: [],//运营商字典
            rechargePermissions:{
                supplierIds:[],
            },


            simConfig:{
                type: null,
            },
            simTypeOptions:[{id: '0', name:'秒嘀'}, {id: '1', name:'雁云'}],

            balanceRechargeLimit: {
                id: []
            }


        }
    },
    methods: {

        updatePayWxImg(){
            common.sysRequest("app/pc/update/pay/wx/img", {id:this.wxSubIdImg,name:this.wxSubKeyImg}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        selectPayWxImg(){
             common.sysRequest("app/pc/select/pay/wx/img", {}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.wxSubIdImg=res.data.data.wxSubId;
                    this.wxSubKeyImg=res.data.data.wxSubKey;
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },

        updatePaydh(){
            common.sysRequest("app/pc/update/pay/dh", {id:this.dhSubId,name:this.dhSubKey}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        selectPaydh(){
             common.sysRequest("app/pc/select/pay/dh", {}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.dhSubId=res.data.data.subId;
                    this.dhSubKey=res.data.data.subKey;
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },



        selectLoad(){
            common.sysRequest("app/pc/get/load/log", {}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.anzuoLoad=res.data.data.anzuoInt;
                    this.pingguoLoad=res.data.data.pingguo;
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },

        updatePayWx(){
            common.sysRequest("app/pc/update/pay/wx", {id:this.wxSubId,name:this.wxSubKey}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        selectPayWx(){
             common.sysRequest("app/pc/select/pay/wx", {}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.wxSubId=res.data.data.wxSubId;
                    this.wxSubKey=res.data.data.wxSubKey;
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },

         updatePayLs(){
            common.sysRequest("app/pc/update/pay/ls", {id:this.lsSubId,name:this.lsSubKey}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        selectPayLs(){
             common.sysRequest("app/pc/select/pay/ls", {}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.lsSubId=res.data.data.lsSubId;
                    this.lsSubKey=res.data.data.lsSubKey;
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },


        updatePayAli(){
            common.sysRequest("app/pc/update/pay/ali", {id:this.aliSubId,name:this.aliSubKey,subKey:this.aliPubKey}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        selectPayAli(){
             common.sysRequest("app/pc/select/pay/ali", {}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.aliSubId=res.data.data.aliSubId;
                    this.aliPubKey=res.data.data.aliPubKey;
                    this.aliSubKey=res.data.data.aliSubKey;
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },


        





        updateSecondBackStateHandler(){
            common.sysRequest("app/pc/changeSim/update", this.huanka, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        updateBindPhoneStateHandler(){
            var data = {
                state: this.bindState
            }
             common.sysRequest("app/pc/update/bind/phone/select", data, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        updateCouponInfoHandler(){
            let self = this;
            let param = {};
            param.coupon_id = self.coupon.id;
            param.id = self.coupon.id;
            param.is_enable = self.coupon.is_enable;
            param.title = self.coupon.title;
            let data = {
                cofValue: JSON.stringify(param)
            };

            updateSysConfigCoupon(data).then(res=>{
                if(res.data.code == 200){
                    this.$message.success('设置成功')
                }else{
                    this.$message.error(res.data.message)
                }
            });
        },
        secondBackDiagnoseHandler(){
           this.lunbo1.appImgCount='appChart1';
            let fd = new FormData();
            Object.keys(this.lunbo1).forEach((key) => {
                fd.append(key, this.lunbo1[key]);
            })
            fd.append('appPopImg',this.$refs.file1.files[0]);
            common.sysRequest("app/pc/chart/update", fd, 'post').then(res=>{
                if(res.data.code == 200){
                     this.selectAll();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
          secondBackDiagnoseHandler1(){
           this.lunbo2.appImgCount='appChart2';
            let fd = new FormData();
            Object.keys(this.lunbo2).forEach((key) => {
                fd.append(key, this.lunbo2[key]);
            })
              fd.append('appPopImg',this.$refs.file2.files[0]);
            common.sysRequest("app/pc/chart/update", fd, 'post').then(res=>{
                if(res.data.code == 200){
                    this.selectAll();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
          secondBackDiagnoseHandler2(){
           this.lunbo3.appImgCount='appChart3';
            let fd = new FormData();
            Object.keys(this.lunbo3).forEach((key) => {
                fd.append(key, this.lunbo3[key]);
            })
            fd.append('appPopImg',this.$refs.file3.files[0]);
            common.sysRequest("app/pc/chart/update", fd, 'post').then(res=>{
                if(res.data.code == 200){
                  this.selectAll();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },

        getPostageConfig(){
            common.sysRequest("sysConfig/postageOrder/query", null, 'post').then(res=>{
                if(res.data.code == 200){
                    for(let key in this.postageForm){
                        this.postageForm[key] = res.data.data[key];
                    }
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },

        updatePostageConfig(){
            let fd = new FormData();
            Object.keys(this.postageForm).forEach((key) => {
                fd.append(key, this.postageForm[key]);
            });
            common.sysRequest("sysConfig/postageOrder", fd, 'post').then(res=>{
                if(res.data.code == 200){
                    this.getPostageConfig();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },
        querySecondBackDiagnose(){
            querySecondBack(null).then(res => {
                if(res.data.code == 200){
                    this.isUserOpen = res.data.data.isUserOpen;
                    this.isAdminOpen = res.data.data.isAdminOpen;
                    this.day = res.data.data.day;
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        remoteMethod(query){
            let self = this;
            if (query && query.length > 0) {
                self.loading = true;
                setTimeout(() => {
                    queryCouponList({"titleLike":query}).then(res=>{
                        if(res.data.code == 200){
                            self.loading = false;
                            self.couponList = res.data.data;
                        }
                      
                       
                    }).catch(err=>console.error(err));
                    
                }, 200);
                
            }
        },

        //收款配置
        collectionConfigHandle(){
            this.$refs["collectionConfigForm"].validate((valid) => {
                if (valid) {
                    this.$confirm("确定保存新修改的数据吗？", "提示" ,{          
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let formdata = new FormData();
                        Object.keys(this.collectionConfigFormdata).forEach((key) => {
                            formdata.append(key, this.collectionConfigFormdata[key]);
                        });

                        adminCollectionConfig(formdata).then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message)
                                this.cancelToSetCollectionConfig(); 
                                //查询总部微信收款配置
                                this.getAdminCollectionConfig();                  
                            }else{
                                this.$message.error(res.data.message)
                            }
                        })
                    }).catch(() => {
                        
                    });
                }
            });

        },
        //取消收款配置
        cancelToSetCollectionConfig(){
            for(let key in this.collectionConfigFormdata){
                this.collectionConfigFormdata[key] = null;
            }
            document.getElementById('secondBack-uploadFile').value = '';
            this.collectPkcsFileName = '';
            this.collectionConfigVisible = false;
        },
        //选择证书文件
        chooseFile(event) {
            let files = event.target.files;
            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断文件是否有效
            }
            let fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.readAsDataURL(files[0])
            this.collectionConfigFormdata.p12 = files[0];
            this.collectPkcsFileName = filename;
        },

        //新增收款配置
        addCollectionConfig(){
            for(let key in this.collectionConfigFormdata){
                this.collectionConfigFormdata[key] = null;
            }
            this.collectionConfigVisible = true;
        },

        //修改收款配置
        updateCollectionConfig(){
            //查询总部微信收款配置
            this.getAdminCollectionConfig();
            this.collectionConfigVisible = true;
        },

        getAdminCollectionConfig(){
            selectAdminCollectionConfig(new FormData()).then(res => {
                if(res.data.code == 200){
                    if(res.data.data){
                        for(let key in res.data.data){
                            this.collectionConfigShowData[key] = res.data.data[key];
                            this.collectionConfigFormdata[key] = res.data.data[key];
                        }
                        this.collectionConfigFormdata.collectPkcsUrl = res.data.data.collectPkcsUrl;
                        this.collectionConfigShowData.collectPkcsUrl = process.env.VUE_APP_IMG_URL + '/' +res.data.data.collectPkcsUrl;
                    }
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },

        //更新总部支付通道
        updatePayChannel(){
            let json = {cofValue:JSON.stringify(this.payChanle)}
            common.sysRequest("/app/pc/pay/channel", json, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                }else{
                    this.$message.error(res.data.message)
                }     
                
            }).catch(err=> console.error(err));
        },


        //查询实名认证配置
        getAuthentication(){
            common.sysRequest("sysConfig/auth/state/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    let d = JSON.parse(res.data.data.cofValue);
                    this.authenticationCinfig.is_enable = Number(d.is_enable) ;
                    this.authenticationCinfig.limit_area = d.limit_area.split(',').map(Number);
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //更改实名认证配置
        updateAuthentication(){
            let data = {
                is_enable: this.authenticationCinfig.is_enable,
                limit_area: this.authenticationCinfig.limit_area.join(",")
            }
            let formData = new FormData();
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            });
            common.sysRequest("sysConfig/auth/state/update", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getAuthentication();
                }     
            }).catch(err=> console.error(err));
        },
        

        //查询流量限额配置
        getFlowLimit(){
            common.sysRequest("sysConfig/sim/data/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.flowLimitConfig = JSON.parse(res.data.data.cofValue);
                    this.flowLimitConfig.states = Number(this.flowLimitConfig.states);
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //更改流量限额配置
        updateFlowLimit(){
            let formData = new FormData();
            Object.keys(this.flowLimitConfig).forEach((key) => {
                formData.append(key, this.flowLimitConfig[key]);
            });

            formData.set("suppliers", formData.get('suppliers').replace(/，/g, ","));
            common.sysRequest("sysConfig/sim/data/update",formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getFlowLimit();
                }     
            }).catch(err=> console.error(err));
        },


        //查询接入号限制登录配置
        getIntoNoLimit(){
            common.sysRequest("sysConfig/sim/intono/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.intoNoLimitConfig = res.data.data;
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //更改接入号限制登录配置
        updateIntoNoLimit(){
            let cofValue = this.intoNoLimitConfig.cofValue;
            common.sysRequest("sysConfig/sim/intono/update", {cofValue: cofValue.replace(/，/g, ",")}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getIntoNoLimit();
                    
                }     
            }).catch(err=> console.error(err));
        },

        

        //查询充值权限
        getRechargePermissions(){
            common.sysRequest("sysConfig/sim/invent/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.rechargePermissions.supplierIds = res.data.data.cofValue.split(",");
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //取消充值权限
        updateRechargePermissions(){
            let formData = new FormData();
            formData.append("supplierIds", this.rechargePermissions.supplierIds.join(","))
            common.sysRequest("sysConfig/sim/invent/update", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getRechargePermissions();
                }     
            }).catch(err=> console.error(err));
        },


        

        //查询短信配置
        getSimConfig(){
            common.sysRequest("sysConfig/sms/select", null, 'get').then(res=>{
                if(res.data.code == 200){
                    this.simConfig.type = res.data.data.cofValue;
                }else{
                    this.$message.error(res.data.message)
                }     
            }).catch(err=> console.error(err));
        },

        //修改短信配置
        updateSimConfig(){
            let formData = new FormData();
            formData.append("type", this.simConfig.type)
            common.sysRequest("sysConfig/sms/update", formData, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                    this.getSimConfig();
                }     
            }).catch(err=> console.error(err));
        },

        // 客服链接
        getBalanceRecharge(){
            common.sysRequest("/app/pc/select/kefu/url", {}, 'post').then(res => {
                this.kefuUrl=res.data.data; 
            })
        },
        updateBalanceRecharge(){
          common.sysRequest("/app/pc/update/kefu/url", {app:this.kefuUrl}, 'post').then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }     
            }).catch(err=> console.error(err));
            
        },

          //更新余额充值限制
        selectAll(){
            //查询总部支付通道
        common.sysRequest("/app/pc/chart/select", null, 'get').then(res=>{
            if(res.data.code == 200){
                this.lunbo1 = res.data.data;
                this.lunTrue1=true;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));

                //查询总部支付通道
        common.sysRequest("/app/pc/chart/select1", null, 'get').then(res=>{
            if(res.data.code == 200){
                 this.lunbo2 = res.data.data;
                  this.lunTrue2=true;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
                //查询总部支付通道 
        common.sysRequest("/app/pc/chart/select2", null, 'get').then(res=>{
            if(res.data.code == 200){
                 this.lunbo3 = res.data.data;
                  this.lunTrue3=true;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
        }
        

    },
    created(){
        this.selectPaydh();
        this.selectPayWxImg();
        this.selectLoad();
        this.selectPayAli();
        this.selectPayLs();
        this.selectPayWx();
        this.getBalanceRecharge();
common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
         //查询总部支付通道
        common.sysRequest("/app/pc/pay/channel/select", null, 'post').then(res=>{
            if(res.data.code == 200){
                this.payChanle = JSON.parse(res.data.data.cofValue);
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
        //查询总部支付通道
        common.sysRequest("/app/pc/chart/select", null, 'get').then(res=>{
            if(res.data.code == 200){
                this.lunbo1 = res.data.data;
                this.lunTrue1=true;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));

                //查询总部支付通道
        common.sysRequest("/app/pc/chart/select1", null, 'get').then(res=>{
            if(res.data.code == 200){
                 this.lunbo2 = res.data.data;
                  this.lunTrue2=true;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
                //查询总部支付通道
        common.sysRequest("/app/pc/chart/select2", null, 'get').then(res=>{
            if(res.data.code == 200){
                 this.lunbo3 = res.data.data;
                  this.lunTrue3=true;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
        //换卡配置
           common.sysRequest("/app/pc/changeSim/select", null, 'get').then(res=>{
            if(res.data.code == 200){
                 this.huanka = res.data.data;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));

         //手机号认证
           common.sysRequest("/app/pc/bind/phone/select", null, 'get').then(res=>{
            if(res.data.code == 200){
                 this.bindState = res.data.data;
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));
        //手机号认证
           common.sysRequest("/app/pc/bind/info/select", null, 'get').then(res=>{
            if(res.data.code == 200){
                this.balanceRechargeLimit.id = res.data.data.split(",");
            }else{
                this.$message.error(res.data.message)
            }     
        }).catch(err=> console.error(err));

    }
}
</script>

<style lang="less" scoped>
#secondBack {
    font-size: 13px;
    h4 {
        color: #409eff;
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin-bottom: 20px;
        margin-left: -8px;
        border-left: 3px solid #409eff;            
    }


    .section1,.section2 {
        margin-bottom: 50px;
        label{
            display: inline-block;
            line-height: 32px;
            vertical-align: middle;
        }
    }

    .section3{
        margin-bottom: 50px;
        label{
            display:inline-block;
        }
        .el-row{
            margin-bottom: 20px;
        }
        span{
            text-align:left;
        }
    }




    .uploadFile{
        opacity: 0;
        height: 32px;
    }

    .toChooseFileBtn{
        position: absolute;
        left: 0;
        top: 0;
        background: none;
        border: 1px solid #DCDFE6;
        color: #606266;
        width: 80px;
        height: 32px;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
    }


    .section1, .section2, .section3{
        padding-bottom: 10px;
        border-bottom: 1px solid #e8f0f5;
    }

}
</style>

